import { XIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { Modal } from '@repo/ui';

import hangingTag from '@assets/images/parking-map/discount-drawer-hanging-tag.png';
import hangingTag1 from '@assets/images/parking-map/discount-drawer-floating-tag-1.png';
import hangingTag2 from '@assets/images/parking-map/discount-drawer-floating-tag-2.png';
import hangingTag3 from '@assets/images/parking-map/discount-drawer-floating-tag-3.png';

interface Props {
  onOpenChange: (open: boolean) => void;
  testId: TestId;
  open: boolean;
}

export default function DiscountModal({ onOpenChange, testId, open }: Props) {
  const handleClose = () => onOpenChange(false);

  return (
    <Modal open={open} onOpenChange={onOpenChange} flush testId={testId}>
      <div className="flex max-h-[75vh] flex-col">
        <div className="relative h-44 w-full overflow-hidden rounded-tl-2xl rounded-tr-2xl">
          <div className="absolute top-0 left-0 h-44 w-full bg-emerald-800" />
          <div className="absolute top-[143px] left-[-62px] h-36 w-36 rounded-full bg-emerald-100 blur-[88.05px]" />
          <div className="absolute top-[-60px] left-[311px] h-36 w-36 rounded-full bg-emerald-100 blur-[88.05px]" />
          <img className="absolute top-0 left-1/2 -translate-x-3/4" src={hangingTag} alt="" aria-hidden />
          <img className="absolute right-20 bottom-0" src={hangingTag3} alt="" aria-hidden />
          <img className="absolute top-0 left-0" src={hangingTag1} alt="" aria-hidden />
          <img className="absolute top-8 right-4" src={hangingTag2} alt="" aria-hidden />
          <button
            className="absolute top-3.5 right-4 z-2 h-5 w-5 cursor-pointer pt-0 pr-0 text-white"
            onClick={handleClose}
            aria-label={tr('actions.close')}
            data-testid={testId.append('close')}
          >
            <XIcon size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-auto px-4 pt-5 pb-3">
          <div className="inline-flex flex-col items-start justify-start gap-4 self-stretch">
            <div className="text-heading text-xl leading-8 font-semibold">
              {tr('parking_search:discount_drawer.title')}
            </div>
            <div className="text-heading justify-start self-stretch opacity-90">
              <span className="text-headingtext-base leading-6 font-medium">
                {tr('parking_search:discount_drawer.prices_dropped')}
              </span>
              <span className="text-headingtext-base leading-6 font-light">
                {tr('parking_search:discount_drawer.description1')}
              </span>
              <br />
              <br />
              <span className="text-headingtext-base leading-6 font-light">
                {tr('parking_search:discount_drawer.description2')}
              </span>
            </div>
            <div className="justify-start self-stretch opacity-90">
              <span className="text-heading text-base leading-6 font-medium">
                {tr('parking_search:discount_drawer.how_it_works')}:
              </span>
              <ol className="text-heading list-inside list-decimal text-base leading-6 font-normal">
                <li>{tr('parking_search:discount_drawer.steps.0')}</li>
                <li>{tr('parking_search:discount_drawer.steps.1')}</li>
                <li>{tr('parking_search:discount_drawer.steps.2')}</li>
              </ol>
            </div>
            <div className="text-heading text-base leading-6 font-medium opacity-90">
              {tr('parking_search:discount_drawer.footer')}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
